import Stack from "components/Stack";

import SectionSummary from "entities/MemoTemplate/components/Sections/SectionSummary";
import { proformaDemoData } from "entities/MemoTemplate/components/Sections/utils";
import { EMemoSourcesAndUsesSectionDisplayMode } from "entities/MemoTemplate/constants";
import SourcesAndUsesConstruction from "entities/Proforma/components/ProformaSourcesAndUses/SourcesAndUsesConstruction";
import SourcesAndUsesPermanent from "entities/Proforma/components/ProformaSourcesAndUses/SourcesAndUsesPermanent";

export interface ISectionSourcesAndUses {
  displayMode: EMemoSourcesAndUsesSectionDisplayMode;
}

const SectionSourcesAndUses = ({ displayMode }: ISectionSourcesAndUses) => {
  return (
    <Stack direction="column" justifyContent="space-between" spacing={4}>
      {[
        EMemoSourcesAndUsesSectionDisplayMode.MIXED,
        EMemoSourcesAndUsesSectionDisplayMode.ONLY_CONSTRUCTION,
      ].includes(displayMode) && (
        <SourcesAndUsesConstruction coreData={proformaDemoData.core_data} />
      )}
      {[
        EMemoSourcesAndUsesSectionDisplayMode.MIXED,
        EMemoSourcesAndUsesSectionDisplayMode.ONLY_PERMANENT,
      ].includes(displayMode) && (
        <SourcesAndUsesPermanent coreData={proformaDemoData.core_data} />
      )}
      <SectionSummary title="Sources and uses description" />
    </Stack>
  );
};

export default SectionSourcesAndUses;
